<template>
    <span class="badge" :class ="type">
        {{ text }}
    </span>
</template>

<script>
export default{
    props: ['type', 'title'],
    computed: {
        text(){
            return this.title.toUpperCase();
        }
    }
}
</script>

<style scoped>
.badge {
  background-color: #ccc;
  color: #252525;
  border-radius: 30px;
  padding: 0.5rem 1.5rem;
  display: inline-block;
  margin-right: 0.5rem;
}

.adhd {
  background-color: #66806A;
  color: white;
}

.anxiety {
  background-color: #483434;
  color: white;
}

.autism {
  background-color: #6B4F4F;
  color: white;
}
.depression{
  background-color: #FFC286;
  color: white;
}
.did {
  background-color: #EED6C4;
  color: white;
}
</style>
